import { render } from "./BattleEnemiesSelectorPanel.vue?vue&type=template&id=2d48367b&scoped=true"
import script from "./BattleEnemiesSelectorPanel.vue?vue&type=script&lang=js"
export * from "./BattleEnemiesSelectorPanel.vue?vue&type=script&lang=js"

import "./BattleEnemiesSelectorPanel.vue?vue&type=style&index=0&id=2d48367b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d48367b"]])

export default __exports__